import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'vpb', en);

const VpbListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Virtual Pill Balance',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.VPB,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/vpb/list',
      component: React.lazy(() => import('./VpbList')),
    },
  ],
};

export default VpbListConfig;
